import React from "react";
import { HelpCircle } from "lucide-react";

/**
 * Small inline glossary affordance: a transparent "?" icon next to a label.
 * It reveals a compact note on hover/focus without behaving like a clickable
 * form control.
 */
export default function GlossaryHint({ term, definition, className = "" }) {
  const id = `glossary-${String(term).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
  return (
    <span className={`checker-help group relative inline-flex items-center ${className}`}>
      <span
        tabIndex={0}
        aria-describedby={id}
        aria-label={`About ${term}`}
        className="checker-help__icon inline-flex h-5 w-5 items-center justify-center focus-visible:outline-none"
      >
        <HelpCircle className="h-3.5 w-3.5" aria-hidden />
      </span>
      <span
        id={id}
        role="tooltip"
        className="checker-help__bubble pointer-events-none absolute left-0 top-full z-30 mt-2 hidden w-[min(22rem,80vw)] px-3 py-2 text-xs leading-relaxed group-hover:block group-focus-within:block"
      >
        <span className="font-semibold">{term}: </span>
        {definition}
      </span>
    </span>
  );
}
